import {Input} from '@mui/material';
import {Button} from 'components/atoms';
import {ButtonSizes} from 'components/atoms/button/constants';
import {
  TypographyFontStyles,
  TypographySizes,
} from 'components/atoms/typography/base-text/constants';
import Headline from 'components/atoms/typography/headline/headline.component';
import {firebaseLogin} from 'network/firebase';
import {useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from 'store/hooks';
import {setIsLoggedIn} from 'store/reducers/login.reducer';
import LIGHT_COLORS from 'theme/colors/light-colors';
import styles from './login.styles';

function Login() {
  const {isLoggedIn} = useAppSelector((state) => state.login);
  const dispatch = useAppDispatch();
  const [email, setEmail] = useState<string>();
  const [password, setPassword] = useState<string>();
  const navigate = useNavigate();

  const onSubmit = () => {
    if (
      (process.env.REACT_APP_USERNAME || email) &&
      (process.env.REACT_APP_PASSWORD || password)
    ) {
      console.log(
        'LOGIN INFO',
        (process.env.REACT_APP_USERNAME || email) as string,
        (process.env.REACT_APP_PASSWORD || password) as string,
      );
      firebaseLogin(
        (process.env.REACT_APP_USERNAME || email) as string,
        (process.env.REACT_APP_PASSWORD || password) as string,
      ).then(
        (userCredentials) => {
          console.log('firebase credentials: ', userCredentials);
          dispatch(setIsLoggedIn(true));
          navigate('/pharmacy/');
        },
        (reason) => console.log(reason),
      );
    }
  };

  return isLoggedIn ? (
    <h1>Already logged in...</h1>
  ) : (
    <div>
      <Headline
        stringProps={{plainText: 'Login'}}
        size={TypographySizes['3XL']}
        fontStyle={TypographyFontStyles.Bold}
      />
      <div style={{margin: 5}}>
        <Input
          style={styles.inputContainerStyle}
          type="email"
          onChange={(ev) => setEmail(ev.target.value)}
        />
      </div>
      <div>
        <Input
          style={styles.inputContainerStyle}
          type="password"
          onChange={(ev) => setPassword(ev.target.value)}
        />
      </div>
      <Button
        textProps={{
          stringProps: {plainText: 'Submit'},
        }}
        size={ButtonSizes.S}
        onClick={onSubmit}
      />
    </div>
  );
}

export default Login;
